// @ts-nocheck
import { getCssVariableHandler } from "../../styles/getCssVariables";
import {
  isOutSorucedContractor,
  isThirdPartyContractor,
} from "../other/otherUtils";

export const getStatusOfContractorOpp = (status) => {
  switch (status) {
    case "applied":
      return "Applied";
    case "not responded":
      return "Pending";
    case "declined":
      return "Declined";
    default:
      return "";
  }
};

export const alertStringForAssignContractor = (data) => {
  switch (data?.status) {
    case "Not Responded":
      return "This contractor has not accepted these opportunities.";
    case "Opportunities Partially accepted":
      return "This contractor has not accepted all the opportunities.";
    default:
      return null;
  }
};

export const getDropdownStatusOfContractorOpp = (data) => {
  switch (data?.status) {
    case "Not Responded":
      return "All Opportunities Pending";

    default:
      return data?.status;
  }
};

const statusColours = {
  green: {
    background: "#03493E",
    color: "#02eec5",
  },
  red: {
    background: "#371414",
    color: "#ff4b4b",
  },
  grey: {
    background: "#ffffff4d",
    color: "white",
  },
  applied: {
    background: "#03493E",
    color: "#02eec5",
  },
  declined: {
    background: "#371414",
    color: "#ff4b4b",
  },
  pending: {
    background: "#ffffff4d",
    color: "white",
  },
};

export const getTagOfStatus = (cont) => {
  if (isThirdPartyContractor({ row: cont })) {
    if (isOutSorucedContractor({ row: cont })) {
      return {
        message: "Oursourced",
        color: "#ffd421",
        backgroundColor: "#8f750a94",
      };
    } else {
      return {
        message: "Third Party",
        color: "#ffd421",
        backgroundColor: "#8f750a94",
      };
    }
  }

  if (cont?.isApproved && cont?.isGustoApproved) {
    return {
      message: "HR App",
      color: statusColours.green.color,
      backgroundColor: statusColours.green.background,
    };
  } else if (cont?.isApproved && !cont?.isGustoApproved) {
    return {
      message: "HR Unapp",
      color: statusColours.red.color,
      backgroundColor: statusColours.red.background,
    };
  } else if (!cont?.isApproved && cont?.isGustoApproved) {
    return {
      message: "Profile Unveri",
      color: statusColours.red.color,
      backgroundColor: statusColours.red.background,
    };
  } else if (!cont?.isApproved && !cont?.isGustoApproved) {
    return {
      message: "Profile Unveri",
      color: statusColours.red.color,
      backgroundColor: statusColours.red.background,
    };
  }
};

// Three separate status badges for the assign / send-opportunity search:
//   1) Verified (isApproved)   2) HR Approved (isGustoApproved)   3) roster status.
// Robust to both the raw user doc (roles[]) and the contractorDetails-wrapped shape
// (rosterStatus, added in contractors-extended.service#toContractorOption).
export const getStatusBadges = (cont) => {
  const g = statusColours.green;
  const r = statusColours.red;
  const neutral = statusColours.grey;
  const flag = (ok, yes, no, tooltip) => ({
    message: ok ? yes : no,
    color: (ok ? g : r).color,
    backgroundColor: (ok ? g : r).background,
    tooltip,
  });
  const rs = (
    cont?.rosterStatus ||
    (Array.isArray(cont?.roles)
      ? (cont.roles.find((x) => x?.role === "contractor") || {}).status
      : "") ||
    ""
  )
    .toString()
    .toLowerCase();
  const rosterLabel = rs ? rs.charAt(0).toUpperCase() + rs.slice(1) : "N/A";
  const rosterColor = rs === "approved" ? g : rs === "rejected" ? r : neutral;
  return [
    flag(
      !!cont?.isApproved,
      "Verified",
      "Not verified",
      "Verified by our team. Only Verified people can be put on a show.",
    ),
    flag(
      !!cont?.isGustoApproved,
      "HR Approved",
      "HR Unapp",
      "HR / Payroll approval (Gusto) — cleared to be paid",
    ),
    {
      message: rosterLabel,
      color: rosterColor.color,
      backgroundColor: rosterColor.background,
      tooltip: "Roster status (approved / pending / invited / rejected)",
    },
  ];
};